import { render, staticRenderFns } from "./ym-sampling.vue?vue&type=template&id=6fc521a2&scoped=true&"
import script from "./ym-sampling.vue?vue&type=script&lang=js&"
export * from "./ym-sampling.vue?vue&type=script&lang=js&"
import style0 from "./ym-sampling.vue?vue&type=style&index=0&id=6fc521a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc521a2",
  null
  
)

export default component.exports